module.exports = __webpack_public_path__ + "static/media/home-event.a87a0a3d.jpg";